module.exports = __webpack_public_path__ + "static/media/connected_world.fbab7777.png";